<template>
    <Modal
        v-model="modal1"
        title="共享"
        @on-ok="ok"
        @on-cancel="cancel">
        <CheckboxGroup v-model="share">
            <Checkbox label="全国"></Checkbox>
            <Checkbox label="区域"></Checkbox>
            <Checkbox label="校本"></Checkbox>
        </CheckboxGroup>
    </Modal>
</template>
<script>
import  api from '../../utils/api.js'
    export default {
        props:{
            isShow:{
                type:Boolean,
                default:false
            },
            datas:{
                type:Object,
                default:{}
            }
        },
        data () {
            return {
                share:[],
                oldShare:[],
                guid:'',
                modal1:false,
                url:'',
                type: ''
            }
        },
        watch:{
            datas(newVal,oldVal){
                this.share = []
                console.log('新值',newVal)
                if(newVal.shareNetId != undefined) this.share.push('全国')
                if(newVal.shareSchoolId != undefined) this.share.push('校本')
                if(newVal.shareWebsiteId != undefined) this.share.push('区域')
                this.oldShare = this.share
                this.guid = newVal.guid
                this.type = newVal.type
            },
            isShow(newVal,oldVal){
                console.log('gengxin')
                this.modal1 = newVal
            }
        },
        mounted () {
        },
        methods: {
            ok () {
                let params = {} 
                if(this.type == 3) {
                    this.url = '/axt-data/dataLearningPlan/updateDataLearningPlan'
                    params.guid = this.guid
                } 
                if(this.type == 2) {
                    this.url = '/axt-data/dataPPT/updateDataPPT'
                    params.guid = this.guid
                } 
                if(this.type == 1) {
                    this.url = '/axt-data/dataVideo/updateDataVideo'
                    params.id = this.guid
                } 
                if(this.type == 4) {
                    this.url = '/axt-data/dataAudio/updateDataAudio'
                    params.id = this.guid
                } 
                if(this.share.indexOf('全国') == -1){
                    params.shareNetId = 0
                } else {
                    params.shareNetId = 1
                }
                if(this.share.indexOf('校本') == -1){
                    params.shareSchoolId = 0
                } else {
                    params.shareSchoolId = localStorage.getItem('schoolId');
                }
                if(this.share.indexOf('区域') == -1) {
                    params.shareWebsiteId = 0
                } else {
                    params.shareWebsiteId = localStorage.getItem('websiteId')
                }
                console.log(params)
                api.postParamsAPI(this.url,params).then(res => {
                })
                this.isShow = false
                this.$emit('closeUpDate','sure')
            },
            cancel () {
                this.isShow = false
                this.$emit('closeUpDate','cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Message/updataData.vue